module.exports = ":root{--lui-flag-background-color:var(--lui-neutral-color)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-flag/theme/lui-flag.global.scss
// module id = 213
// module chunks = 0 1 33